import {
  FormControl,
  FormLabel,
  Grid,
  Input,
  Stack,
  Switch,
  Textarea,
} from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import { Select } from "chakra-react-select";
import WebhookSelect from "./WebhookSelect";

export default function DetailsForm({ formDetailsForm, attributesForm }) {
  const { register, control, watch, setValue } = formDetailsForm;
  const typeOfForms = [
    { label: "Simple form", value: "simple" },
    { label: "Natural form", value: "natural" },
  ];

  return (
    <Stack spacing={2} w={"100%"}>
      <Grid gap={3} gridTemplateColumns={"1fr 1fr"} spacing={3}>
        <FormControl isRequired>
          <FormLabel>Type of Form</FormLabel>
          <Controller
            name="type"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <Select
                options={typeOfForms}
                value={typeOfForms.find((c) => c.value === value)}
                onChange={(val) => onChange(val.value)}
              />
            )}
          />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Name</FormLabel>
          <Input
            placeholder="Name"
            value={watch("name")}
            onChange={(e) => setValue("name", e.currentTarget.value)}
            name="name"
          />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Trigger Instructions</FormLabel>
          <Textarea
            defaultValue={watch("triggerInstructions")}
            {...register("triggerInstructions")}
            name="triggerInstructions"
          />
        </FormControl>
        <FormControl>
          <FormLabel>Webhook</FormLabel>
          <WebhookSelect
            webhook_id={watch("webhook_id")}
            onChangeWebhook={(value) =>
              value
                ? formDetailsForm.setValue("webhook_id", value.value)
                : formDetailsForm.setValue("webhook_id", null)
            }
          />
          <Link to={"/settings/webhooks"}>Create Webhook</Link>
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Label for Submit</FormLabel>
          <Input {...register("attributes.submit_label")} />
        </FormControl>
        <FormControl
          display={"flex"}
          justifyContent={"flex-start"}
          alignItems={"center"}
        >
          <FormLabel>Is submission mandatory ?</FormLabel>
          <Switch
            isChecked={attributesForm.watch("mandatory_submission")}
            onChange={(e) => {
              attributesForm.setValue(
                "mandatory_submission",
                e.currentTarget.checked
              );
            }}
          />
        </FormControl>
      </Grid>
    </Stack>
  );
}
